// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function readAllInventory(query) {
    let baseUrl = config.INVENTORY_URL;

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    return api.get(`${baseUrl}`, {});
}

function createInventory(inventoryRequest) {
    const baseUrl = config.INVENTORY_URL;
    return api.create(`${baseUrl}`, inventoryRequest);
}

function updateInventory(inventoryId, inventoryRequest) {
    const baseUrl = config.INVENTORY_URL + '/' + inventoryId;
    return api.update(`${baseUrl}`, inventoryRequest);
}

function deleteInventory(inventoryId) {
    const baseUrl = config.INVENTORY_URL + '/' + inventoryId;
    return api.delete(`${baseUrl}`, {});
}

export {
    readAllInventory,
    createInventory,
    updateInventory,
    deleteInventory,
};
